import * as configActions from './config.actions';
import { ErrorHandlerService } from '../../../app/services/error-handler.service';

export interface State {
    lastSyncDown: {[key: string]: string};
    authToken: string;
    refreshToken: string;
    restHost: string;
    restEndpoint: string;
}

export const initialState: State = {
    lastSyncDown: {},
    authToken: '',
    refreshToken: '',
    restHost: '',
    restEndpoint: undefined
};

// tslint:disable-next-line:only-arrow-functions
export function reducer(state = initialState, action: configActions.Actions): State {
    switch (action.type) {
        case configActions.CLEAR_LAST_SYNC_DOWN_DATES: {
            return {
                ...state,
                lastSyncDown: {}
            };
        }
        case configActions.SET_LAST_SYNC_DOWN: {
            if (!action.payload || !action.payload.accountId) {
                console.warn('accountId of undefined', action);
                return;
            }
            return {
                ...state,
                lastSyncDown: {
                    [action.payload.accountId]: action.payload.date
                }
            };
        }
        case configActions.SET_AUTH_TOKEN: {
            return {
                ...state,
                authToken: action.payload
            };
        }
        case configActions.SET_REFRESH_TOKEN: {
            return {
                ...state,
                refreshToken: action.payload
            };
        }
        case configActions.SET_REST_HOST: {
            return {
                ...state,
                restHost: action.payload
            };
        }
        case configActions.SET_REST_ENDPOINT: {
            return {
                ...state,
                restEndpoint: action.payload
            };
        }
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/config/config.reducer.ts